try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx, jsxs } from 'react/jsx-runtime';
import { Icon } from '@design-system/icon';
import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import { forwardRef, useState } from 'react';

const Chip = forwardRef(({ className, text, disabled, isSelected = false, onClick }, ref) => {
    const [selected, setSelected] = useState(isSelected);
    const handleClick = () => {
        if (!disabled) {
            setSelected((prev) => !prev);
            onClick === null || onClick === void 0 ? void 0 : onClick();
        }
    };
    return (jsx("div", Object.assign({ ref: ref, className: classNames('chip', className) }, { children: jsx("button", Object.assign({ type: "button", className: classNames('chip__button', {
                'chip--selected': selected,
            }), onClick: handleClick, onMouseDown: (e) => e.preventDefault(), disabled: disabled }, { children: jsxs("div", Object.assign({ className: "chip__content-container" }, { children: [jsx(Typography, { tag: "span", variant: "body", size: "s", content: text }), selected && jsx(Icon, { icon: "close", size: 12 })] })) })) })));
});

export { Chip };
